/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SupportRouteImport } from './routes/support'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as OutpatientPatientsRouteImport } from './routes/outpatient/patients'
import { Route as HcpAdminUsersRouteImport } from './routes/hcp-admin/users'
import { Route as HcpAdminArchiveRouteImport } from './routes/hcp-admin/archive'
import { Route as CustomerAdminUsersRouteImport } from './routes/customer-admin/users'
import { Route as CustomerAdminPatientsRouteImport } from './routes/customer-admin/patients'
import { Route as CustomerAdminIdnsRouteImport } from './routes/customer-admin/idns'
import { Route as AbbottAdminAbbottRouteImport } from './routes/abbott-admin/abbott'
import { Route as HcpAdminDepartmentsIndexRouteImport } from './routes/hcp-admin/departments.index'
import { Route as CustomerAdminDepartmentsIndexRouteImport } from './routes/customer-admin/departments.index'
import { Route as HcpAdminUsersUserIdRouteImport } from './routes/hcp-admin/users/$userId'
import { Route as HcpAdminDepartmentsDepartmentIdRouteImport } from './routes/hcp-admin/departments.$departmentId'
import { Route as CustomerAdminUsersUserIdRouteImport } from './routes/customer-admin/users/$userId'
import { Route as CustomerAdminIdnsIDNIdRouteImport } from './routes/customer-admin/idns/$IDNId'
import { Route as ActivationTokenLegalRouteImport } from './routes/activation/$token.legal'
import { Route as ActivationTokenAccountRouteImport } from './routes/activation/$token.account'

const SupportRoute = SupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const OutpatientPatientsRoute = OutpatientPatientsRouteImport.update({
  id: '/outpatient/patients',
  path: '/outpatient/patients',
  getParentRoute: () => rootRouteImport,
} as any)
const HcpAdminUsersRoute = HcpAdminUsersRouteImport.update({
  id: '/hcp-admin/users',
  path: '/hcp-admin/users',
  getParentRoute: () => rootRouteImport,
} as any)
const HcpAdminArchiveRoute = HcpAdminArchiveRouteImport.update({
  id: '/hcp-admin/archive',
  path: '/hcp-admin/archive',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomerAdminUsersRoute = CustomerAdminUsersRouteImport.update({
  id: '/customer-admin/users',
  path: '/customer-admin/users',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomerAdminPatientsRoute = CustomerAdminPatientsRouteImport.update({
  id: '/customer-admin/patients',
  path: '/customer-admin/patients',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomerAdminIdnsRoute = CustomerAdminIdnsRouteImport.update({
  id: '/customer-admin/idns',
  path: '/customer-admin/idns',
  getParentRoute: () => rootRouteImport,
} as any)
const AbbottAdminAbbottRoute = AbbottAdminAbbottRouteImport.update({
  id: '/abbott-admin/abbott',
  path: '/abbott-admin/abbott',
  getParentRoute: () => rootRouteImport,
} as any)
const HcpAdminDepartmentsIndexRoute =
  HcpAdminDepartmentsIndexRouteImport.update({
    id: '/hcp-admin/departments/',
    path: '/hcp-admin/departments/',
    getParentRoute: () => rootRouteImport,
  } as any)
const CustomerAdminDepartmentsIndexRoute =
  CustomerAdminDepartmentsIndexRouteImport.update({
    id: '/customer-admin/departments/',
    path: '/customer-admin/departments/',
    getParentRoute: () => rootRouteImport,
  } as any)
const HcpAdminUsersUserIdRoute = HcpAdminUsersUserIdRouteImport.update({
  id: '/$userId',
  path: '/$userId',
  getParentRoute: () => HcpAdminUsersRoute,
} as any)
const HcpAdminDepartmentsDepartmentIdRoute =
  HcpAdminDepartmentsDepartmentIdRouteImport.update({
    id: '/hcp-admin/departments/$departmentId',
    path: '/hcp-admin/departments/$departmentId',
    getParentRoute: () => rootRouteImport,
  } as any)
const CustomerAdminUsersUserIdRoute =
  CustomerAdminUsersUserIdRouteImport.update({
    id: '/$userId',
    path: '/$userId',
    getParentRoute: () => CustomerAdminUsersRoute,
  } as any)
const CustomerAdminIdnsIDNIdRoute = CustomerAdminIdnsIDNIdRouteImport.update({
  id: '/$IDNId',
  path: '/$IDNId',
  getParentRoute: () => CustomerAdminIdnsRoute,
} as any)
const ActivationTokenLegalRoute = ActivationTokenLegalRouteImport.update({
  id: '/activation/$token/legal',
  path: '/activation/$token/legal',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivationTokenAccountRoute = ActivationTokenAccountRouteImport.update({
  id: '/activation/$token/account',
  path: '/activation/$token/account',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/support': typeof SupportRoute
  '/abbott-admin/abbott': typeof AbbottAdminAbbottRoute
  '/customer-admin/idns': typeof CustomerAdminIdnsRouteWithChildren
  '/customer-admin/patients': typeof CustomerAdminPatientsRoute
  '/customer-admin/users': typeof CustomerAdminUsersRouteWithChildren
  '/hcp-admin/archive': typeof HcpAdminArchiveRoute
  '/hcp-admin/users': typeof HcpAdminUsersRouteWithChildren
  '/outpatient/patients': typeof OutpatientPatientsRoute
  '/activation/$token/account': typeof ActivationTokenAccountRoute
  '/activation/$token/legal': typeof ActivationTokenLegalRoute
  '/customer-admin/idns/$IDNId': typeof CustomerAdminIdnsIDNIdRoute
  '/customer-admin/users/$userId': typeof CustomerAdminUsersUserIdRoute
  '/hcp-admin/departments/$departmentId': typeof HcpAdminDepartmentsDepartmentIdRoute
  '/hcp-admin/users/$userId': typeof HcpAdminUsersUserIdRoute
  '/customer-admin/departments': typeof CustomerAdminDepartmentsIndexRoute
  '/hcp-admin/departments': typeof HcpAdminDepartmentsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/support': typeof SupportRoute
  '/abbott-admin/abbott': typeof AbbottAdminAbbottRoute
  '/customer-admin/idns': typeof CustomerAdminIdnsRouteWithChildren
  '/customer-admin/patients': typeof CustomerAdminPatientsRoute
  '/customer-admin/users': typeof CustomerAdminUsersRouteWithChildren
  '/hcp-admin/archive': typeof HcpAdminArchiveRoute
  '/hcp-admin/users': typeof HcpAdminUsersRouteWithChildren
  '/outpatient/patients': typeof OutpatientPatientsRoute
  '/activation/$token/account': typeof ActivationTokenAccountRoute
  '/activation/$token/legal': typeof ActivationTokenLegalRoute
  '/customer-admin/idns/$IDNId': typeof CustomerAdminIdnsIDNIdRoute
  '/customer-admin/users/$userId': typeof CustomerAdminUsersUserIdRoute
  '/hcp-admin/departments/$departmentId': typeof HcpAdminDepartmentsDepartmentIdRoute
  '/hcp-admin/users/$userId': typeof HcpAdminUsersUserIdRoute
  '/customer-admin/departments': typeof CustomerAdminDepartmentsIndexRoute
  '/hcp-admin/departments': typeof HcpAdminDepartmentsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/support': typeof SupportRoute
  '/abbott-admin/abbott': typeof AbbottAdminAbbottRoute
  '/customer-admin/idns': typeof CustomerAdminIdnsRouteWithChildren
  '/customer-admin/patients': typeof CustomerAdminPatientsRoute
  '/customer-admin/users': typeof CustomerAdminUsersRouteWithChildren
  '/hcp-admin/archive': typeof HcpAdminArchiveRoute
  '/hcp-admin/users': typeof HcpAdminUsersRouteWithChildren
  '/outpatient/patients': typeof OutpatientPatientsRoute
  '/activation/$token/account': typeof ActivationTokenAccountRoute
  '/activation/$token/legal': typeof ActivationTokenLegalRoute
  '/customer-admin/idns/$IDNId': typeof CustomerAdminIdnsIDNIdRoute
  '/customer-admin/users/$userId': typeof CustomerAdminUsersUserIdRoute
  '/hcp-admin/departments/$departmentId': typeof HcpAdminDepartmentsDepartmentIdRoute
  '/hcp-admin/users/$userId': typeof HcpAdminUsersUserIdRoute
  '/customer-admin/departments/': typeof CustomerAdminDepartmentsIndexRoute
  '/hcp-admin/departments/': typeof HcpAdminDepartmentsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/signup'
    | '/support'
    | '/abbott-admin/abbott'
    | '/customer-admin/idns'
    | '/customer-admin/patients'
    | '/customer-admin/users'
    | '/hcp-admin/archive'
    | '/hcp-admin/users'
    | '/outpatient/patients'
    | '/activation/$token/account'
    | '/activation/$token/legal'
    | '/customer-admin/idns/$IDNId'
    | '/customer-admin/users/$userId'
    | '/hcp-admin/departments/$departmentId'
    | '/hcp-admin/users/$userId'
    | '/customer-admin/departments'
    | '/hcp-admin/departments'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/signup'
    | '/support'
    | '/abbott-admin/abbott'
    | '/customer-admin/idns'
    | '/customer-admin/patients'
    | '/customer-admin/users'
    | '/hcp-admin/archive'
    | '/hcp-admin/users'
    | '/outpatient/patients'
    | '/activation/$token/account'
    | '/activation/$token/legal'
    | '/customer-admin/idns/$IDNId'
    | '/customer-admin/users/$userId'
    | '/hcp-admin/departments/$departmentId'
    | '/hcp-admin/users/$userId'
    | '/customer-admin/departments'
    | '/hcp-admin/departments'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/signup'
    | '/support'
    | '/abbott-admin/abbott'
    | '/customer-admin/idns'
    | '/customer-admin/patients'
    | '/customer-admin/users'
    | '/hcp-admin/archive'
    | '/hcp-admin/users'
    | '/outpatient/patients'
    | '/activation/$token/account'
    | '/activation/$token/legal'
    | '/customer-admin/idns/$IDNId'
    | '/customer-admin/users/$userId'
    | '/hcp-admin/departments/$departmentId'
    | '/hcp-admin/users/$userId'
    | '/customer-admin/departments/'
    | '/hcp-admin/departments/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  SignupRoute: typeof SignupRoute
  SupportRoute: typeof SupportRoute
  AbbottAdminAbbottRoute: typeof AbbottAdminAbbottRoute
  CustomerAdminIdnsRoute: typeof CustomerAdminIdnsRouteWithChildren
  CustomerAdminPatientsRoute: typeof CustomerAdminPatientsRoute
  CustomerAdminUsersRoute: typeof CustomerAdminUsersRouteWithChildren
  HcpAdminArchiveRoute: typeof HcpAdminArchiveRoute
  HcpAdminUsersRoute: typeof HcpAdminUsersRouteWithChildren
  OutpatientPatientsRoute: typeof OutpatientPatientsRoute
  ActivationTokenAccountRoute: typeof ActivationTokenAccountRoute
  ActivationTokenLegalRoute: typeof ActivationTokenLegalRoute
  HcpAdminDepartmentsDepartmentIdRoute: typeof HcpAdminDepartmentsDepartmentIdRoute
  CustomerAdminDepartmentsIndexRoute: typeof CustomerAdminDepartmentsIndexRoute
  HcpAdminDepartmentsIndexRoute: typeof HcpAdminDepartmentsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/outpatient/patients': {
      id: '/outpatient/patients'
      path: '/outpatient/patients'
      fullPath: '/outpatient/patients'
      preLoaderRoute: typeof OutpatientPatientsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hcp-admin/users': {
      id: '/hcp-admin/users'
      path: '/hcp-admin/users'
      fullPath: '/hcp-admin/users'
      preLoaderRoute: typeof HcpAdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hcp-admin/archive': {
      id: '/hcp-admin/archive'
      path: '/hcp-admin/archive'
      fullPath: '/hcp-admin/archive'
      preLoaderRoute: typeof HcpAdminArchiveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer-admin/users': {
      id: '/customer-admin/users'
      path: '/customer-admin/users'
      fullPath: '/customer-admin/users'
      preLoaderRoute: typeof CustomerAdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer-admin/patients': {
      id: '/customer-admin/patients'
      path: '/customer-admin/patients'
      fullPath: '/customer-admin/patients'
      preLoaderRoute: typeof CustomerAdminPatientsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer-admin/idns': {
      id: '/customer-admin/idns'
      path: '/customer-admin/idns'
      fullPath: '/customer-admin/idns'
      preLoaderRoute: typeof CustomerAdminIdnsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/abbott-admin/abbott': {
      id: '/abbott-admin/abbott'
      path: '/abbott-admin/abbott'
      fullPath: '/abbott-admin/abbott'
      preLoaderRoute: typeof AbbottAdminAbbottRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hcp-admin/departments/': {
      id: '/hcp-admin/departments/'
      path: '/hcp-admin/departments'
      fullPath: '/hcp-admin/departments'
      preLoaderRoute: typeof HcpAdminDepartmentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer-admin/departments/': {
      id: '/customer-admin/departments/'
      path: '/customer-admin/departments'
      fullPath: '/customer-admin/departments'
      preLoaderRoute: typeof CustomerAdminDepartmentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hcp-admin/users/$userId': {
      id: '/hcp-admin/users/$userId'
      path: '/$userId'
      fullPath: '/hcp-admin/users/$userId'
      preLoaderRoute: typeof HcpAdminUsersUserIdRouteImport
      parentRoute: typeof HcpAdminUsersRoute
    }
    '/hcp-admin/departments/$departmentId': {
      id: '/hcp-admin/departments/$departmentId'
      path: '/hcp-admin/departments/$departmentId'
      fullPath: '/hcp-admin/departments/$departmentId'
      preLoaderRoute: typeof HcpAdminDepartmentsDepartmentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer-admin/users/$userId': {
      id: '/customer-admin/users/$userId'
      path: '/$userId'
      fullPath: '/customer-admin/users/$userId'
      preLoaderRoute: typeof CustomerAdminUsersUserIdRouteImport
      parentRoute: typeof CustomerAdminUsersRoute
    }
    '/customer-admin/idns/$IDNId': {
      id: '/customer-admin/idns/$IDNId'
      path: '/$IDNId'
      fullPath: '/customer-admin/idns/$IDNId'
      preLoaderRoute: typeof CustomerAdminIdnsIDNIdRouteImport
      parentRoute: typeof CustomerAdminIdnsRoute
    }
    '/activation/$token/legal': {
      id: '/activation/$token/legal'
      path: '/activation/$token/legal'
      fullPath: '/activation/$token/legal'
      preLoaderRoute: typeof ActivationTokenLegalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activation/$token/account': {
      id: '/activation/$token/account'
      path: '/activation/$token/account'
      fullPath: '/activation/$token/account'
      preLoaderRoute: typeof ActivationTokenAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface CustomerAdminIdnsRouteChildren {
  CustomerAdminIdnsIDNIdRoute: typeof CustomerAdminIdnsIDNIdRoute
}

const CustomerAdminIdnsRouteChildren: CustomerAdminIdnsRouteChildren = {
  CustomerAdminIdnsIDNIdRoute: CustomerAdminIdnsIDNIdRoute,
}

const CustomerAdminIdnsRouteWithChildren =
  CustomerAdminIdnsRoute._addFileChildren(CustomerAdminIdnsRouteChildren)

interface CustomerAdminUsersRouteChildren {
  CustomerAdminUsersUserIdRoute: typeof CustomerAdminUsersUserIdRoute
}

const CustomerAdminUsersRouteChildren: CustomerAdminUsersRouteChildren = {
  CustomerAdminUsersUserIdRoute: CustomerAdminUsersUserIdRoute,
}

const CustomerAdminUsersRouteWithChildren =
  CustomerAdminUsersRoute._addFileChildren(CustomerAdminUsersRouteChildren)

interface HcpAdminUsersRouteChildren {
  HcpAdminUsersUserIdRoute: typeof HcpAdminUsersUserIdRoute
}

const HcpAdminUsersRouteChildren: HcpAdminUsersRouteChildren = {
  HcpAdminUsersUserIdRoute: HcpAdminUsersUserIdRoute,
}

const HcpAdminUsersRouteWithChildren = HcpAdminUsersRoute._addFileChildren(
  HcpAdminUsersRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  SignupRoute: SignupRoute,
  SupportRoute: SupportRoute,
  AbbottAdminAbbottRoute: AbbottAdminAbbottRoute,
  CustomerAdminIdnsRoute: CustomerAdminIdnsRouteWithChildren,
  CustomerAdminPatientsRoute: CustomerAdminPatientsRoute,
  CustomerAdminUsersRoute: CustomerAdminUsersRouteWithChildren,
  HcpAdminArchiveRoute: HcpAdminArchiveRoute,
  HcpAdminUsersRoute: HcpAdminUsersRouteWithChildren,
  OutpatientPatientsRoute: OutpatientPatientsRoute,
  ActivationTokenAccountRoute: ActivationTokenAccountRoute,
  ActivationTokenLegalRoute: ActivationTokenLegalRoute,
  HcpAdminDepartmentsDepartmentIdRoute: HcpAdminDepartmentsDepartmentIdRoute,
  CustomerAdminDepartmentsIndexRoute: CustomerAdminDepartmentsIndexRoute,
  HcpAdminDepartmentsIndexRoute: HcpAdminDepartmentsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
